<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="/">
              Inicio
            </a>
          </li>
          <li>
            <a href="/productos">
              Productos
            </a>
          </li>
          <li>
            <a href="/carrito">
              Carrito de Compras
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, derechos reservados - GatewayIT
        <a
          href="https:///www.invisionapp.com"
          target="_blank"
          rel="noopener"
        ></a>.
        <!-- Coded by
        <a href="https://binarcode.com" target="_blank" rel="noopener"
          ></a
          > -->
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
